import { render, staticRenderFns } from "./addProductEther.vue?vue&type=template&id=0d116b81"
import script from "./addProductEther.vue?vue&type=script&lang=js"
export * from "./addProductEther.vue?vue&type=script&lang=js"
import style0 from "./addProductEther.vue?vue&type=style&index=0&id=0d116b81&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports